// extracted by mini-css-extract-plugin
module.exports = {"menuWrapper":"LocationsContextMenu__menuWrapper___3-vSB","menuItem":"LocationsContextMenu__menuItem___33Cqq"};